import Config from '@/config';

let serverPerfStart = null;

const getServerPerfStart = () => {
    if (serverPerfStart !== null) {
        return serverPerfStart;
    }

    let serverTime;
    try {
        serverTime = new Date(Config.get('config')?.serverTime).getTime();
    } catch (e) {
        serverTime = null;
    }

    const clientPerfStart = performance.now();
    const fallbackClientNow = Date.now();

    serverPerfStart = serverTime
        ? serverTime - clientPerfStart
        : fallbackClientNow - clientPerfStart;

    return serverPerfStart;
};

/**
 * Возвращает текущее "серверное" время.
 * Автоматически fallback'ается на Date.now() если serverTime не определён.
 */
export const getServerNow = () => {
    return getServerPerfStart() + performance.now();
};
